import { render, staticRenderFns } from "./NewProductCataloguePage.vue?vue&type=template&id=6abb9060&scoped=true"
import script from "./NewProductCataloguePage.vue?vue&type=script&lang=js"
export * from "./NewProductCataloguePage.vue?vue&type=script&lang=js"
import style0 from "./NewProductCataloguePage.vue?vue&type=style&index=0&id=6abb9060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb9060",
  null
  
)

export default component.exports